<template>
  <div
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
  >
    <v-data-table
        dense
        :headers="columns"
        :items="itemList"
        item-key="id"
        class="elevation-5 text-caption"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        show-select
        v-model="selectedItemList"
        :footer-props="{'items-per-page-options': [20, 50, 100]}"
        :height="windowHeight"
        :search="searchTerm"
        fixed-header
        @click:row="onClickRow"
    >
      <template v-slot:top>
        <v-toolbar dense class="pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              @input="onUpdateSearchTerm"
              clearable
          ></v-text-field>
          <v-text-field
              dark
              v-model="searchTermFile"
              label="File search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTermFile"
          ></v-text-field>
          <v-spacer></v-spacer>
          <StoreFileDialog
              v-if="storeDocItemId != null"
              :isAdd="true"
              :storeDocItemId="storeDocItemId"
              :dialogProps.sync="dragDialog"
          >
          </StoreFileDialog>
          <v-btn
              class="mt-n2 mx-2"
            @click="onHistoryClick">
            History
          </v-btn>
          <v-checkbox
              dark
              class="mt-4"
              :input-value="previewPanel"
              @change="onSwitchChange"
              off-icon="mdi-arrow-collapse-left"
              on-icon="mdi-arrow-collapse-right"
          >
          </v-checkbox>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon v-if="selectedItemId === item.id">
            mdi-arrow-right-bold
        </v-icon>
      </template>
      <template v-slot:item.edited_on="{ item }">
        {{ item.edited_on | moment("YY.MM.DD HH:mm") }}
      </template>
      <template v-slot:item.title="{ item }">
        <div v-html="item.title" class="text-caption"
             :class="{ 'title-cell' : item.id != selectedItemId}"></div>
      </template>
      <template v-slot:item.file_name="{ item }">
        <a :href="item.file" target="target">{{ item.file_name }}</a>
      </template>
      <template v-slot:item.store_doc="{ item }">
        <router-link :to="{name:'StoreDocItem', params: { storeDocItemId: item.store_doc}}">
          {{ item.store_doc_title }}
        </router-link>
      </template>
      <template v-slot:item.id="{ item }">
        <v-container fluid>
          <v-row>
            <StoreFileDialog
                icon="mdi-pencil"
                color="primary"
                small
                :itemId="item.id"
                :storeDocItemId="item.store_doc"
            >
            </StoreFileDialog>
          </v-row>
        </v-container>
      </template>
    </v-data-table>
    <v-toolbar flat dense v-if="isAlive">
      <BaseDeleteDialog :disabled="!(selectedItemList.length > 0)" :loading="deleteLoading"
                        :onDeleteAction="onRemoveItems" title="Remove selected"></BaseDeleteDialog>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-toolbar flat dense v-else>
      <v-btn
          color="primary"
          class="mx-4"
          @click="onRestore"
          :loading="restoring"
          :disabled="!(selectedItemList.length > 0)"
      >
        Restore selected
      </v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import StoreFileDialog from "@/components/StoreFile/StoreFileDialog";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import CommonArray from "@/commonFunction/arrayFunction";
import StoreFileHistory from "@/components/StoreFile/StoreFileHistory";
import BaseModal from "@/components/Base/BaseModal";

export default {
  name: 'BaseStoreFileList',

  inheritAttrs: false,
  props: {
    'storeDocItemId': [String, Number],
    'previewPanel': [Boolean],
    'searchTermFileParam': {type: [String, Number], default: null},
    'hide-default-footer': {type: Boolean, default: false},
    'windowHeight': {default: 800},
  },

  components: {
    BaseModal,
    StoreFileDialog,
    BaseDeleteDialog,
    StoreFileHistory,
  },

  computed: {
    ...mapGetters('StoreFile', ['getColumns']),
    ...mapFields('StoreFile', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'editedItem', 'previewLink']),
  },

  methods: {
    ...mapActions('StoreFile', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchRestoreSelectedItems']),
    ...mapMutations('StoreFile', ['updateSearchTermFile', 'updateFilters']),
    ...mapActions('StoreFileHistory', {'fetchFileHistoryItemList': 'fetchItemList'}),
    onUpdateSearchTerm() {
      this.fetchItemList();
    },
    onUpdateSearchTermFile() {
      this.fetchItemList();
    },
    updateOptions() {
      this.fetchItemList()
    },
    onRestore() {
      // console.log('onRestore')
      this.fetchRestoreSelectedItems();
    },
    onRemoveItems() {
      // console.log('onRemoveItems')
      this.fetchDeleteSelectedItem()
    },
    onClickRow(item, event) {
      // console.log('onClickRow', item, event)
      this.selectedItemId = item.id
      this.fetchFileHistoryItemList(this.selectedItemId)
      this.previewLink = item.preview_link
      this.content = item.content
      this.file_name = item.file_name
      let iframe = document.getElementById('iframe-view');
      if (iframe != null) {
        const src = iframe.src
        iframe.src = null;
        iframe.src = src;
      }
    },
    onHistoryClick() {
      this.$router.push({name:this.$router.currentRoute.name + '_BaseHistoryFile',params: {storeDocItemId: this.storeDocItemId}})
    },
    onDrop(e) {
      // console.log('onDrop', e, e.dataTransfer.files, e.dataTransfer.items, e.dataTransfer.types)
      this.dragover = false;
      if (e.dataTransfer.files.length > 1) {
        this.$toast.warning("Only one file can be uploaded at a time..", {timeout: 5000})
      } else {
        for (const file of e.dataTransfer.files) {
          this.editedItem = {title: file.name, file: file, store_doc: this.storeDocItemId}
          // console.log('Add new', this.newItem)
          if (this.storeDocItemId != null)
            this.dragDialog = true
        }
      }
    },
    onSwitchChange(event) {
      console.log('onSwitchChange', event)
      this.$emit('update:previewPanel', event)
    },
  },

  async mounted() {
    // console.log('searchTermFile', this.previewLink)
    this.updateFilters({store_doc_id: this.storeDocItemId})
    this.updateSearchTermFile(this.searchTermFileParam)
    // this.$store.commit('updateStoreDocItemId', this.storeDocItemId)
    // await this.fetchItemList({store_doc_id: this.storeDocItemId});
  },

  data() {
    return {
      selectedItemId: null,
      dragDialog: false,
      widthImage: this.$vuetify.breakpoint.width * 0.4,
      newDialog: false,
      dialogDelete: false,
      newItem: {},
      // previewLink: [null, null],
      content: null,
      file_name: '',
      columns: [
        {text: '', value: 'actions', sortable: true, divider: true, width: 40},
        {text: '', value: 'id', sortable: true, divider: true, width: 40},
        // {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, width:100},
        {
          text: 'Created by',
          value: 'created_by__username',
          sortable: true,
          filterable: true,
          divider: true,
          width: 100
        },
        // {text: 'Edited by', value: 'edited_by__username', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, width: 140},
        // {text: 'Created by', value: 'created_by__username', sortable: true, filterable: true, divider: true, width:100},
        {text: 'Source type', value: 'source_type', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'Title', value: 'title', sortable: true, filterable: true, divider: true},
        {text: 'File', value: 'file_name', sortable: false, divider: true, width: 200},
        // {text: 'Store doc', value: 'store_doc', sortable: true, divider: true},
        // {text: 'Content', value: 'content', sortable: false, divider: true},
      ],
    }
  }
}

</script>

<style scoped lang="scss">
.preview-iframe {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.card_space {
  height: calc(100vh - 50px);
  //overflow-y: auto;
}

.main_space {
  height: calc(100vh - 100px);
  //overflow-y: auto;
}

.table-space {
  height: calc(100vh - 200px);
  //overflow-y: auto;
}

.image-preview {
  overflow-x: scroll;
  overflow-y: auto;
}

.image-slider {
  width: 500px
}

.title-cell {
  max-height: 2em;
  overflow-y: hidden
}
</style>
